import type { ComponentProps } from 'react'
import * as React from 'react'
import CarouselLockedCardLoadingSkeleton from './CarouselLockedCardLoadingSkeleton'
import type OfferCardMapper from './OfferCardMapper'
import CarouselCardLoadingSkeleton from './CarouselCardLoadingSkeleton'
import GrowthCarouselCardLoadingSkeleton from './GrowthOfferCard/GrowthCarouselCardLoadingSkeleton'

type InheritedOfferCardProps = Pick<ComponentProps<typeof OfferCardMapper>, 'variant' | 'size'>

interface Props extends InheritedOfferCardProps, React.HTMLAttributes<HTMLDivElement> {
  growthTile?: boolean
  mobileWidth?: '75vw' | '80vw'
}

function OfferCardLoadingSkeleton({ variant = 'card-default', size = 'small', growthTile = false, mobileWidth, ...rest }: Props) {
  if (growthTile) {
    return <GrowthCarouselCardLoadingSkeleton {...rest} locked={variant === 'card-locked'} mobileWidth={mobileWidth} />
  }

  if (variant === 'card-default' || variant === 'card-opaque') {
    return <CarouselCardLoadingSkeleton {...rest} size={size} variant={variant === 'card-opaque' ? 'opaque' : 'default'} />
  }

  if (variant === 'card-locked') {
    return <CarouselLockedCardLoadingSkeleton {...rest} size={size} />
  }
}

export default OfferCardLoadingSkeleton
